//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import theme from './TableControls.scss';
import { ButtonWithPopover, ButtonTypes } from 'common/components/core/button';
import { PopoverTriggerEnum } from 'common/components/core/popover/popOverFactory';
class TableControls extends React.PureComponent {
    handleClick = () => {
        const { onDelete, row } = this.props;
        onDelete && onDelete(row);
    };

    render() {
        const { theme, disableDeleteButton, deleteButtonTooltip } = this.props;
        return (
            <ButtonWithPopover
                buttonType={ButtonTypes.Icon}
                className={theme.controlButton}
                theme={theme}
                icon="delete-bin"
                disabled={disableDeleteButton}
                onClick={this.handleClick}
                triggerPopoverOn={PopoverTriggerEnum.Hover}
                popOverContent={deleteButtonTooltip}
            />
        );
    }
}

export default themr('TableControls', theme)(TableControls);
